"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import Chart from "chart.js/auto";
const COLORS = ["#1f6f43", "#c51f2d", "#d59f0f", "#315b7d", "#76520b", "#5b4b8a"];
const readSeries = (element) => {
  try {
    return JSON.parse(element.dataset.series || "[]");
  } catch (_error) {
    return [];
  }
};
const chartConfiguration = (kind, series) => {
  const labels = series.map((row) => row.label);
  const values = series.map((row) => row.value);
  const common = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: kind === "doughnut", position: "bottom" },
      tooltip: { callbacks: { label: (context) => `${context.label}: ${context.formattedValue}` } }
    }
  };
  if (kind === "line") {
    return {
      type: "line",
      data: { labels, datasets: [{ label: "Signatures", data: values, borderColor: COLORS[0], backgroundColor: "rgba(31, 111, 67, 0.16)", fill: true, tension: 0.2 }] },
      options: __spreadProps(__spreadValues({}, common), {
        scales: {
          // Chart.js requires the one-character axis key.
          // eslint-disable-next-line id-length
          y: { beginAtZero: true, ticks: { precision: 0 } }
        }
      })
    };
  }
  if (kind === "doughnut") {
    return {
      type: "doughnut",
      data: { labels, datasets: [{ data: values, backgroundColor: COLORS, borderColor: "#ffffff", borderWidth: 2 }] },
      options: common
    };
  }
  return {
    type: "bar",
    data: { labels, datasets: [{ label: "Signatures", data: values, backgroundColor: COLORS[3] }] },
    options: __spreadProps(__spreadValues({}, common), {
      indexAxis: series.length > 8 ? "y" : "x",
      scales: {
        // Chart.js requires the one-character axis keys.
        // eslint-disable-next-line id-length
        x: { beginAtZero: true, ticks: { precision: 0 } },
        // eslint-disable-next-line id-length
        y: { beginAtZero: true, ticks: { precision: 0 } }
      }
    })
  };
};
const initializeCharts = (root) => {
  root.querySelectorAll("canvas[data-analytics-chart]").forEach((canvas) => {
    if (canvas.dataset.initialized === "true") {
      return;
    }
    const series = readSeries(canvas);
    if (series.length === 0) {
      return;
    }
    canvas.dataset.initialized = "true";
    canvas.analyticsChart = new Chart(canvas, chartConfiguration(canvas.dataset.analyticsChart, series));
  });
};
const normalizeCounty = (name) => name.toString().toUpperCase().replace(/COUNTY/g, "").replace(/[^A-Z]/g, "");
const colorFor = (value, maximum) => {
  if (!value) {
    return "#e5e7eb";
  }
  const intensity = Math.max(0.18, value / Math.max(maximum, 1));
  const lightness = Math.round(88 - intensity * 50);
  return `hsl(145 48% ${lightness}%)`;
};
const allCoordinates = (coordinates) => {
  if (typeof (coordinates == null ? void 0 : coordinates[0]) === "number") {
    return [coordinates];
  }
  return (coordinates || []).flatMap(allCoordinates);
};
const geometryRings = (geometry) => {
  if (geometry.type === "Polygon") {
    return geometry.coordinates;
  }
  if (geometry.type === "MultiPolygon") {
    return geometry.coordinates.flat();
  }
  return [];
};
const renderGeographicMap = (container, geojson, series) => {
  const width = 760;
  const height = 720;
  const padding = 18;
  const coordinates = geojson.features.flatMap((feature) => allCoordinates(feature.geometry.coordinates));
  const longitudes = coordinates.map((point) => point[0]);
  const latitudes = coordinates.map((point) => point[1]);
  const minX = Math.min(...longitudes);
  const maxX = Math.max(...longitudes);
  const minY = Math.min(...latitudes);
  const maxY = Math.max(...latitudes);
  const scale = Math.min((width - padding * 2) / (maxX - minX), (height - padding * 2) / (maxY - minY));
  const values = new Map(series.map((row) => [normalizeCounty(row.label), row.value]));
  const maximum = Math.max(...series.map((row) => row.value), 1);
  const namespace = "http://www.w3.org/2000/svg";
  const svg = document.createElementNS(namespace, "svg");
  svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
  svg.setAttribute("role", "img");
  svg.setAttribute("aria-label", "Kenya county participation choropleth map");
  const project = ([longitude, latitude]) => [
    padding + (longitude - minX) * scale,
    height - padding - (latitude - minY) * scale
  ];
  geojson.features.forEach((feature) => {
    const county = feature.properties.county || feature.properties.County || feature.properties.COUNTY || "County";
    const value = values.get(normalizeCounty(county));
    const pathData = geometryRings(feature.geometry).map((ring) => `${ring.map((point, index) => {
      const [projectedX, projectedY] = project(point);
      return `${index === 0 ? "M" : "L"}${projectedX.toFixed(2)},${projectedY.toFixed(2)}`;
    }).join(" ")} Z`).join(" ");
    const path = document.createElementNS(namespace, "path");
    path.setAttribute("d", pathData);
    path.setAttribute("fill", colorFor(value, maximum));
    path.setAttribute("stroke", "#ffffff");
    path.setAttribute("stroke-width", "0.8");
    const title = document.createElementNS(namespace, "title");
    title.textContent = `${county}: ${value != null ? value : "suppressed or no signatures"}`;
    path.append(title);
    svg.append(path);
  });
  container.replaceChildren(svg);
};
const renderTileFallback = (container, series) => {
  const maximum = Math.max(...series.map((row) => row.value), 1);
  const grid = document.createElement("div");
  grid.className = "kenya-map-fallback";
  series.forEach((row) => {
    const tile = document.createElement("div");
    tile.style.backgroundColor = colorFor(row.value, maximum);
    tile.textContent = `${row.label} ${row.value}`;
    grid.append(tile);
  });
  container.replaceChildren(grid);
};
const initializeMaps = (root) => {
  root.querySelectorAll("[data-kenya-choropleth]").forEach((container) => __async(null, null, function* () {
    if (container.dataset.initialized === "true") {
      return;
    }
    container.dataset.initialized = "true";
    const series = readSeries(container);
    if (series.length === 0) {
      return;
    }
    try {
      const response = yield fetch(container.dataset.boundariesUrl, { headers: { Accept: "application/geo+json,application/json" } });
      if (!response.ok) {
        throw new Error("County boundary request failed");
      }
      renderGeographicMap(container, yield response.json(), series);
    } catch (_error) {
      renderTileFallback(container, series);
    }
  }));
};
const initializeAnalytics = () => {
  document.querySelectorAll("[data-participation-analytics]").forEach((root) => {
    initializeCharts(root);
    initializeMaps(root);
  });
};
document.addEventListener("DOMContentLoaded", initializeAnalytics);
document.addEventListener("turbo:load", initializeAnalytics);
